import React from 'react';
import MeetingsVariant from './Variants/Meetings/MyContentPanel.meetings';
import { PresentableModelORM } from 'src/state/context/ContentProvider/ContentProvider';

interface MyContentPanelProps {
  onClosePanel?: () => void;
  /** TODO: Determine the purpose/necessity of this prop. */
  addGap?: boolean;
  displayContentPanel: boolean;
  sessionId?: string;
  onSelectPresentableORM?: (orm: PresentableModelORM, slide?: number) => void;
}

const MyContentPanel: React.FC<MyContentPanelProps> = props => {
  return <MeetingsVariant {...props} />
}

MyContentPanel.displayName = 'ContentPanel';

export default MyContentPanel;
